import 'arrive';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import componentFactory from './factories/vue.component.factory';

Vue.config.productionTip = false;
Vue.use(BootstrapVue);

export const vueId = 'vue-app-inject';
const vueSelector = `#${vueId}`;

export const vueArrivedHandler = () => {
  const component = componentFactory.getNewVueApp();
  document.getElementById(vueId).appendChild(component.$el);
};
document.arrive(vueSelector, vueArrivedHandler);



// WEBPACK FOOTER //
// ./src/main.js